import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./LotteryCRUD";
import { lotterySlice } from "./LotterySlice";

const { actions } = lotterySlice;

export const getLotteryResultUI = () => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchLotteryResultUI()
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryResultUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryResultUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getLotteryList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchLotteryList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getLotteryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .fetchLotteryDetail(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const getLotteryUI = () => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchLotteryUI()
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getLotteryPrizeUI = () => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchLotteryPrizeUI()
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryPrizeUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryPrizeUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getLotteryHistory = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchLotteryHistory(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryHistoryFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryHistory");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getLotteryHistoryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .fetchLotteryHistoryDetail(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.LotteryHistoryDetailFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchLotteryHistoryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const buyLottery = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .buyLottery(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryBought({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: buyLottery");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const voidLottery = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .voidLottery(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryVoided({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: voidLottery");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const reorderLottery = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .reorderLottery(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.LotteryReordered({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: reorderLottery");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const getCompanyGameBalance = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.DETAIL }));

  return requestToApi
    .fetchCompanyGameBalance(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.companyGameBalanceFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCompanyGameBalance");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.DETAIL })
      );
      throw error;
    });
};
